import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { InsuranceRusPayload, InsuranceRusData } from './external-link-tracking.types';

// deprecated service ref.: postInsuranceExternalLinks_DEPRECATED
export async function trackExternalLinkService({ body }: InsuranceRusPayload) {
  const { response, data } = await BACKEND.post<InsuranceRusData>(ENDPOINT.RUS_QUOTE_SILOBAG, { body });

  return {
    response,
    summary: data,
  };
}
